import Alpine from 'alpinejs';

const phoneNumberControl = ({ name, isEn }) => ({
    name,

    async init() {
        const intlTelInput = (await import('intl-tel-input')).default;

        const uiTranslations = isEn
            ? (await import('intl-tel-input/locale/en')).default
            : (await import('intl-tel-input/locale/sv')).default;

        // The visible input strips the country code from the value
        this.$refs.input.value = this.$refs.hiddenInput.value;

        const iti = intlTelInput(this.$refs.input, {
            loadUtils: () => import('intl-tel-input/utils'),
            containerClass: 'block',
            uiTranslations,
            initialCountry: 'se',
            separateDialCode: true,
            hiddenInputs: () => ({
                phone: name,
            }),
        });

        this.destroy = () => {
            iti.destroy();
        };

        this.updateHiddenInput = () => {
            this.$refs.hiddenInput.value = iti.getNumber();
        };

        this.$watch('isSubmitting', (isSubmitting) => {
            iti.setDisabled(isSubmitting);
        });
    },

    onInput() {
        this.updateHiddenInput();
    },

    onCountryChange() {
        this.updateHiddenInput();
    },

    onFocusOut() {
        this.form.touch(name).validate();
    },
});

Alpine.data(
    'app_view_components_forms_precognitive_PhoneNumberControl',
    phoneNumberControl,
);
